<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="cs-keyword-import-modal"
      dialog-width="40rem"
      dialog-max-height="40rem"
    >
      <template #header>
        {{ ls({ ja: 'キーワード検索設定', en: 'Keyword Search Settings' }) }}
      </template>
      <div class="jps-modal-content">
        <div class="jps-field">
          <label class="jps-label">{{
            lss(
              'キーワード検索の対象フィールド',
              'Target fields for keyword search',
            )
          }}</label>
          <div class="jps-tag-list jps-block">
            <!--表示-->
            <UiDbField
              class="jps-tag jps-dark jps-slim jps-tag-ricon"
              v-for="(f, ind) in csValue.keywordFields"
              :field="f"
              :key="ind"
              :deletable="true"
              @delete="removeFromArray(csValue.keywordFields, f)"
            />
            <button
              type="button"
              class="jps-round-button jps-orange"
              @click.stop="selectKeywordFields"
            >
              {{ lss('検索項目を追加する', 'Add search field') }}
            </button>
          </div>
        </div>

        <ValidationForm :target="csValue" :rule="otherRule" />
        <p class="jps-message jps-red" v-if="!valid">
          {{
            lss(
              'キーワード検索用項目を1つ以上設定してください',
              'Select one or more fields for keyword search',
            )
          }}
        </p>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
        <button @click="confirm()" :disabled="!valid">{{ ls(dapLangGlobal.ok) }}</button>
      </template>
    </UiModalDialog>
    <UiDbFieldSelectModal ref="dbFieldSelectModal" />
  </BaseModal>
</template>


<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal, UiDbFieldSelectModal } from '#components'

const { ls, lss } = useI18n()

interface Props {
  editstate?: CsEditState
}
const props = withDefaults(defineProps<Props>(),{
})

const modal = ref<InstanceType<typeof BaseModal>>()
const _editstate: Ref<CsEditState> = ref()
const csValue:Ref<CustomSearchDefinition> = ref(null)
const openAwait = async (options?: Props) => {
  setOptionsValue(_editstate, 'editstate', props, options)

  let cs: CustomSearchDefinition = clone(_editstate.value.cs)
  if (!cs.keywordFields) cs.keywordFields = []
  if (!cs.keywordPlaceholder) cs.keywordPlaceholder = {}
  csValue.value = cs

  return await modal.value.openAwait<CustomSearchDefinition>()
}
defineExpose({ openAwait })

const otherRule: ValidationRule = {
  fields: {
    keywordPlaceholder: {
      field: 'keywordPlaceholder',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'キーワードプレイスホルダー',
        en: 'Keyword Placeholder',
      },
    },
  },
}

const valid = computed(() => {
  return csValue.value.keywordFields.length > 0
})

const confirm = () => {
  modal.value.resolve(csValue.value)
}

const dbFieldSelectModal = ref<InstanceType<typeof UiDbFieldSelectModal>>()
const selectKeywordFields = async () => {
  try {
    const keyword = await dbFieldSelectModal.value.openAwait({
      fields: csValue.value.keywordFields,
      database: _editstate.value.db,
      indexType: ['string', 'html'],
    })
    csValue.value.keywordFields = keyword
  } catch (error) {}
}
</script>
